"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = exports.CircleButton = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var CircleButton = _styledComponents["default"].button.withConfig({
  displayName: "IconButton__CircleButton",
  componentId: "rvk2ch-0"
})(["display:flex;align-items:center;justify-content:center;width:", "px;height:", "px;border:0;border-radius:99px;background:transparent;cursor:pointer;flex-shrink:0;background-position:center;transition:background 0s;&:hover{background:", " radial-gradient( circle,transparent 1%,", " 1% ) center/15000%;transition:0.4s;}&:active{background-color:", ";background-size:100%;transition:background 0s;}"], function (_ref) {
  var size = _ref.size;
  return size;
}, function (_ref2) {
  var size = _ref2.size;
  return size;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.dark[7];
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.dark[6];
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.dark[6];
});

exports.CircleButton = CircleButton;

var IconButton = function IconButton(_ref6) {
  var onClick = _ref6.onClick,
      icon = _ref6.icon,
      size = _ref6.size,
      iconColor = _ref6.iconColor,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref6, ["onClick", "icon", "size", "iconColor"]);
  return _react["default"].createElement(CircleButton, (0, _extends2["default"])({
    onClick: onClick,
    size: size
  }, props), _react["default"].createElement(_Icon["default"], {
    name: icon,
    height: "100%",
    color: iconColor
  }));
};

IconButton.defaultProps = {
  size: 48
};
IconButton.propTypes = {
  onClick: _propTypes["default"].func.isRequired,
  icon: _propTypes["default"].string.isRequired,
  size: _propTypes["default"].number
};
var _default = IconButton;
exports["default"] = _default;